import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, useTheme } from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 20px;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
  }
`;
export const Marker = React.memo(function Marker({ title, informative, positive, warning, negative, className, dataTestId, }) {
    const { colors } = useTheme();
    const color = React.useMemo(() => {
        if (informative)
            return colors.link100;
        if (positive)
            return colors.positive100;
        if (warning)
            return colors.warning100;
        if (negative)
            return colors.critical100;
        return colors.grey100_1;
    }, [colors, informative, positive, warning, negative]);
    return (_jsx(Wrapper, { "$color": color, className: className, "data-testid": dataTestId, children: title }));
});
